module.exports = __webpack_public_path__ + "media/images/social-share-button/pinterest-e1a7ea454b158f6c3fd633c7bc122723.svg";